/*
 * Filename: d:\projects\AutoFiFront\src\Content\OrderBy\OrderByHolder\OrderByHolder.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Monday, January 30th 2023, 5:49:27 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import React, { useEffect, useRef, useState } from "react";
import OrderBySelected from "Content/OrderBy/OrderBySelected/OrderBySelected";
import styles from "Content/OrderBy/OrderByHolder/OrderByHolder.module.css";

export type OrderByHolderType = {
    id: string,
    getCurrentlyActiveAndOrder: (action: string) => Promise<void>
    curOrderBy: {name: string, order: string},
    themeColor: string,
};

function OrderByHolder (props : OrderByHolderType) {
    const [curActive, setCurActive] = useState("");
    const [curOrder, setCurOrder] = useState("");
    const [sellPriceActive, setSellPriceActive] = useState("notActivated");
    const [rentalCostActive, setRentalCostActive] = useState("notActivated");
    const [mileageActive, setMileageActive] = useState("notActivated");
    const [circulationDateActive, setCirculationDateActive] = useState("notActivated");
    const orderByList = [ {name: "sell_price", val: sellPriceActive},
                        // {name: "rental_cost", val: rentalCostActive},
                        {name: "mileage", val: mileageActive},
                        {name: "circulation_date", val: circulationDateActive}];
    const firstLoad = useRef(true);


    const operationDict =  new Map()
    operationDict.set("sell_price", {activeFunc: setSellPriceActive, otherFunc:[setRentalCostActive, setMileageActive, setCirculationDateActive]});
    operationDict.set("rental_cost", {activeFunc: setRentalCostActive, otherFunc:[setSellPriceActive, setMileageActive, setCirculationDateActive]});
    operationDict.set("mileage", {activeFunc: setMileageActive, otherFunc:[setRentalCostActive, setSellPriceActive, setCirculationDateActive]});
    operationDict.set("circulation_date", {activeFunc: setCirculationDateActive, otherFunc:[setRentalCostActive, setMileageActive, setSellPriceActive]});

    useEffect(() => {
        setCurrentlyActiveAndOrder(props.curOrderBy.name, props.curOrderBy.order);
    }, [props.curOrderBy]);

    useEffect(() => {
        if (firstLoad.current) {
            setCurrentlyActiveAndOrder(props.curOrderBy.name, props.curOrderBy.order);
            firstLoad.current = (false);
        }
    },[]);

    var setCurrentlyActiveAndOrder = (active: string, order: string) =>{
        if (operationDict.has(active)) {
            operationDict.get(active).activeFunc(order);
            operationDict.get(active).otherFunc.forEach((element: Function) => {
                element("notActivated");
            });
            if (!firstLoad.current && (active != curActive || order != curOrder)) {
                setCurActive(active);
                setCurOrder(order);
                props.getCurrentlyActiveAndOrder(`${active + "," + order}`);
            }
        }  else {
            setCurActive("");
            setCurOrder("");
            operationDict.forEach((val, key, map) => {
                val.activeFunc("notActivated");
            })
        }
    };

    return (
        <React.Fragment>
            <div className={`${styles.orderByHolder}`}>
                {
                    orderByList.map((item: {name: string, val: string}, index: number) => {
                        return <OrderBySelected
                            key={item.name + index}
                            name={item.name}
                            sort={item.val}
                            themeColor={props.themeColor}
                            changeState={setCurrentlyActiveAndOrder}
                            />
                        }
                    )
                }
            </div>
        </React.Fragment>
    );
}

export default OrderByHolder;
